module.exports = __webpack_public_path__ + "static/img/cont45_04.495b4b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45_04.jpg
// module id = kZfj
// module chunks = 0